import React, { useState, useEffect } from "react";

const messages = [
  {
    heading: "Welcome to Excellent Motors",
    subtext: "Your trusted Yamaha Dealer",
  },
  {
    heading: "Exchange Your Ride",
    subtext: "Get up to ₹3000 off on bike/scooter exchange",
  },
  {
    heading: "Experience Pure Performance",
    subtext: "Explore our latest Yamaha models today",
  },
];

const Banner1 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % messages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative w-full h-screen overflow-hidden text-white" style={{ top: '-11px', backgroundColor: 'black' }}>
      {/* YouTube Video Background for Desktop */}
      <div className="hidden sm:block absolute top-0 left-0 w-full h-screen z-0 overflow-hidden">
        <iframe
          className="absolute top-0 left-0 w-full h-screen"
          src="https://www.youtube.com/embed/MI5QjPayvKE?start=5&autoplay=1&controls=0&mute=1&modestbranding=1&rel=0&showinfo=0"
          title="Yamaha Promo Video Desktop"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          style={{
            width: "100vw",
            height: "100vh",
            minWidth: "100vw",
            minHeight: "100vh",
            objectFit: "cover",
            border: "none",
          }}
        ></iframe>
      </div>
      {/* YouTube Video Background for Mobile */}
      <div
        className="block sm:hidden absolute top-0 left-0 w-full min-h-screen z-0 overflow-hidden"
        style={{ height: "100dvh" }}
      >
        <iframe
          className="w-full h-full"
          src="https://www.youtube.com/embed/yiaTyuD5vAw?si=SE0NcRghk8QaZZe2&start=7&autoplay=1&controls=0&mute=1&modestbranding=1&rel=0&showinfo=0&loop=1&playlist=yiaTyuD5vAw"
          title="Yamaha Promo Video Mobile"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          style={{ minWidth: "100vw", minHeight: "100dvh",  height: "134vh", marginTop:"-129px"}}
        ></iframe>
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-10 z-10"></div>

      {/* Text Carousel */}
      <div
        className="absolute left-1/2 transform -translate-x-1/2 z-20 text-center px-4 w-full max-w-md sm:max-w-xl"
        style={{
          backgroundColor: 'black',
          paddingTop: '10px',
          paddingBottom: '10px',
          bottom: '24px',
        }}
      >
        <div key={currentSlide} className="animate-slideInLeft duration-300 flex flex-col items-center">
          <h1 className="text-xl sm:text-3xl font-extrabold mb-1 leading-snug">
            {messages[currentSlide].heading}
          </h1>
          <p className="text-sm sm:text-lg mb-3 text-white/90">
            {messages[currentSlide].subtext}
          </p>

          <div className="flex flex-col items-center gap-3">
            <a
              href="#models"
              className="bg-yellow-500 text-blue-900 px-6 py-3 rounded-full text-base sm:text-lg font-semibold hover:bg-yellow-400 whitespace-nowrap inline-block shadow-lg"
            >
              Explore Our Models
            </a>

            <a
              href="tel:+919818922508"
              className="inline-flex flex-col items-center text-sm sm:text-base font-medium text-white/90 hover:text-yellow-300 transition-colors duration-200"
              aria-label="Call +91 9818922508"
            >
              <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-red-500 drop-shadow-sm">Call Now</span>
              <span className="mt-0.5 text-base sm:text-lg font-semibold">+91 9818922508</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner1;